import {UserDto} from '@domain/pom'
import {SEARCH_DELAY_IN_MS} from '@hconnect/common/consts'
import {SxProps, Theme} from '@mui/material'
import {useDebounce} from '@react-hook/debounce'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {usePomUsers} from '../../hooks'

import {ResponsiblePersonFormField} from './ResponsiblePersonFormField'

type ResponsiblePersonFieldProps = {
  value?: UserDto
  onChange: (user?: UserDto) => void
  required?: boolean
  error?: boolean
  sx?: SxProps<Theme>
}

export const ResponsiblePersonField: React.FC<ResponsiblePersonFieldProps> = ({
  value,
  onChange,
  required = false,
  error = false,
  sx
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [debouncedNamePattern, setDebouncedNamePattern] = useDebounce('', SEARCH_DELAY_IN_MS)
  const {data, isFetching} = usePomUsers(debouncedNamePattern, !!debouncedNamePattern)

  return (
    <ResponsiblePersonFormField
      sx={sx}
      error={error}
      required={required}
      value={value}
      onChange={onChange}
      onInputChange={setDebouncedNamePattern}
      persons={data ?? []}
      loading={isFetching}
      label={t('actionDialog.assignee')}
    />
  )
}
